import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import OwlCarousel from "react-owl-carousel"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel/dist/assets/owl.theme.default.css"
import { Modal } from "reactstrap"
import countryCode from "utils/countryCode"

import hornbillFestival from "../../assets/hornbill-festival.pdf"
import { createTripStatus } from "store/actions"

const options = {
  loop: false,
  nav: false,
  dots: false,
  autoplay: true,
  smartSpeed: 1000,
  autoplayTimeout: 5000,
  autoHeight: true,
  items: 1,
  animateOut: "fadeOut",
}

const URL = {
  PROD: "https://server.happy60plus.com",
  TEST: "https://test.server.happy60plus.com",
}

const TripSC = () => {
  const dispatch = useDispatch()
  const [display, setDisplay] = useState(false)
  const [modal, setModal] = useState(false)
  const [isOpen, setKnowMore] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [showError, setShowError] = useState(false)
  const [isFormSubmitted, setFormSubmitted] = useState(false)
  const [selectedCountry, setCountry] = useState("+91")
  const [errors, setError] = useState({
    name: false,
    mobileNumber: false,
    serviceID: false,
  })
  let timeout
  const toggle = () => setModal(!modal)
  const knowMore = () => setKnowMore(!isOpen)

  useEffect(() => {
    setDisplay(true)
  }, [])

  useEffect(() => {
    return () => {
      clearTimeout(timeout)
      timeout = undefined
    }
  }, [])

  function isValid(formSubmitted = false) {
    if (!formSubmitted && !isFormSubmitted) {
      return
    }

    const form = document.getElementById("EnquiryForm")
    const formData = new FormData(form)
    const data = Object.fromEntries(formData.entries())

    let isValid = true
    const error = {
      name: false,
      mobileNumber: false,
      //   serviceID: showService && !data.serviceID,
    }

    for (const [key, value] of Object.entries(data)) {
      if (!value || value.trim() === "") {
        if (key !== "email") {
          error[key] = true
          isValid = false
        }
        if (key === "pincode") {
          error[key] = false
          isValid = true
        }
      } else if (key === "mobileNumber") {
        const regex = /^[0-9 ~@#$^*()_+=[\]{}|\\,.?: -]{10,15}$/
        const isValidPhone = regex.test(value)
        if (!isValidPhone) {
          error[key] = true
          isValid = false
        }
      }
    }
    setError(error)
    return isValid
  }

  const handleSubmit = event => {
    event.preventDefault()
    setFormSubmitted(true)
    const formData = new FormData(event.target)
    const formJSON = Object.fromEntries(formData.entries())
    if (isValid(true)) {
      // formJSON.mobileNumber = formJSON.dialCode + formJSON.mobileNumber
      // formJSON.mobileNumber = formJSON.mobileNumber.slice(1)
      formJSON.countryCode = formJSON.dialCode.slice(1)
      formJSON.status = "RAISED"
      formJSON.type = "TOUR_AND_TRIP_ENQUIRY"
      delete formJSON.dialCode
      // dispatch(createTripStatus(formJSON))

      let url = URL.PROD
      if (
        window.location.hostname.indexOf("test") !== -1 ||
        window.location.hostname == "localhost"
      ) {
        url = URL.TEST
      }

      const serviceListUrl = `${url}/data-service/api/enquiry/save`
      fetch(serviceListUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formJSON),
      })
        .then(response => response.json())
        .then(() => {
          setShowSuccess(true)
          try {
            event?.target?.reset()
          } catch (error) {
            console.log(error)
          }
          // addData(true);
          timeout = setTimeout(() => {
            toggle()
            setShowSuccess(false)
          }, 3000)
        })
        .catch(error => {
          setShowError(true)
          timeout = setTimeout(() => {
            setShowError(false)
          }, 3000)
        })
    }
    return false
  }

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-lg-6 col-sm-6">
          <div className="single-ml-services-box">
            <h2>A Trip to Assam & Nagaland</h2>
            <h4>7N/8D</h4>
            <p>
              The hills of Nagaland are home to seventeen indigenous Naga tribes
              who are great warriors, talented musicians and skilled craftsmen.
              Travellers from all over the world come here to observe the Nagas
              age-old tribal traditions, hear fascinating tales from their
              folklore, sample unique delicacies, and witness their colourful
              festivals.
            </p>
            <p>
              Assam, the big sibling among the seven sister states of
              NortheastIndia, is a mustsee on the itinerary of anyone visiting
              NortheastIndia. Tea, silk crafts, Bihu folk dance, and one-horned
              rhinoceros have made Assam well-known globally.
            </p>
            <hr />
            <div className="row">
              <div className="col-lg-6 col-sm-6 text-center">
                <button onClick={knowMore} className="btn btn-gradient btn-lg">
                  Know More
                </button>
              </div>
              <div className="col-lg-6 col-sm-6 text-center">
                <button onClick={toggle} className="btn btn-gradient btn-lg ">
                  Enquiry
                </button>
              </div>
            </div>
            <hr />
            {display ? (
              <OwlCarousel
                className="ml-feedback-slides owl-carousel owl-theme"
                {...options}
              >
                <div className="single-testimonials-item remove-before">
                  <div className="owl-details">
                    <p>
                      Arrive to a warm welcome at Lokpriya Gopinath Bordoloi
                      International Airport, Guwahati, historically referred to
                      as the gateway to Northeast India. Visit some of the
                      famous attractions of Guwahati - Kamakhya Temple,
                      Brahmaputra River Heritage Centre and Umananda Temple.
                    </p>
                  </div>
                  <div className="client-info">
                    <h3>Guwahati</h3>
                    <span>28 November 2023</span>
                  </div>
                </div>
                <div className="single-testimonials-item remove-before">
                  <div className="owl-details">
                    <p>
                      Proceed to Kaziranga, famous for being home to the rare
                      one-horned rhinoceros (approx. travel time: 5.5 hrs).
                      After some rest, visit the National Orchid and
                      Biodiversity Park, the largest orchid park in the country.
                      Here, you will find over 500 different species of orchids
                      during blooming season, numerous species of local fruits,
                      leafy vegetables, bamboos, medicinal plants, rice
                      specimens and native fishes. The Orchid Park is also a
                      great place for shopping local handicraft and handloom
                      products. Watch a few cultural programs in the evening
                      before you retire for the day.
                    </p>
                    <p>
                      Spend the evening in the calm tranquility of this animal
                      kingdom.
                    </p>
                    <p>
                      Go for an early morning elephant safari for a rendezvous
                      with the rare one-horned rhinoceros. After some rest, go
                      on an afternoon jeep safari of the park.
                    </p>
                  </div>
                  <div className="client-info">
                    <h3>Kaziranga</h3>
                    <span>29 November 2023 - 30 November 2023</span>
                  </div>
                </div>
                <div className="single-testimonials-item remove-before">
                  <div className="owl-details">
                    <p>
                      Proceed to the historic city of Kohima, capital of
                      Nagaland and one of the two important theatres of World
                      War II in India where the British-Indian army fought
                      against the Japanese invaders in 1944 (approx. travel
                      time: 6.5 hrs).
                    </p>

                    <p>
                      Spend the day at the Hornbill Festival, popularly known as
                      the Festival of Festivals. Watch traditional performances
                      amid a riot of colours, check out local Naga cuisine and
                      shop traditional art and handicraft. Spend the evening
                      walking through the bustling night bazaar.
                    </p>

                    <p>
                      Spend the first half of the day at the festival ground.
                      For the rest of the day, check out the remaining
                      attractions around Kohima such as the War Cemetery that is
                      a tribute to the soldiers who died in the Japanese attack
                      of 1944, Nagaland State Museum, Kohima Cathedral Church,
                      etc.
                    </p>

                    <p>
                      Go on a day’s excursion to the beautiful historical
                      village of Khonoma (approx. travel time one way: 1.5 hrs),
                      located amidst terraced rice fields and sprawling acres of
                      community forests. Walk and explore the fortified Angami
                      village which was attacked several times by the British
                      colonists.
                    </p>

                    <p>
                      Khonoma is also known as ‘GreenVillage’ since it was the
                      first village in Nagaland to abandon hunting in 1998.
                      Return to Kohima.
                    </p>
                  </div>
                  <div className="client-info">
                    <h3>Kohima</h3>
                    <span>1 December 2023 - 5 December 2023</span>
                  </div>
                </div>
              </OwlCarousel>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <Modal
        id="YogaModal"
        isOpen={modal}
        centered={true}
        className="modal-dialog-centered"
      >
        <div className="modal-header" style={{ borderBottom: "none" }}>
          <button
            type="button"
            className="btn-close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={toggle}
          ></button>
        </div>

        <div className="faq-contact triangle-yoga">
          <div className="enquiry-wrapper">
            <h3
              className="text-uppercase text-white text-center p-3"
              style={{
                fontSize: "1.8rem",
                marginBottom: "0.5rem",
              }}
            >
              Itinerary for Assam & Nagaland (7N/8D)
            </h3>
            {/* <h5
              className="text-uppercase text-white text-center"
              style={{
                fontSize: "1rem",
              }}
            >
              INCLUSIONS
            </h5> */}
            {/* <ul
              style={{
                margin: "0 auto",
                width: 400,
                textAlign: "start",
              }}
            >
              <li>Premium accommodation on double occupancy basis</li>
              <li>Breakfast on all days at the property</li>
              <li>SUV on all days</li>
              <li>One Elephant Safari at Kaziranga National Park</li>
              <li>One Elephant Safari at Kaziranga National Park</li>
              <li>One Jeep Safari at Kaziranga National Park</li>
              <li>Inner line permit for Nagaland</li>
              <li>Anvayins representative in Nagaland</li>
              <li>One Ethnic Lunch at Khonoma on 4 December 2023</li>
              <li>All toll and taxes</li>
            </ul> */}
            <form
              id="EnquiryForm"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
            >
              <div className="row">
                <div className="col-lg-12 col-md-12 p-3 px-5">
                  <div className="form-group" style={{ marginBottom: "-18px" }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      className={`form-control ${errors.name && "is-invalid"}`}
                      style={{
                        fontSize: "1.2rem",
                      }}
                      onChange={() => isValid()}
                    />
                    <div className="invalid-feedback">
                      Your name is required.
                    </div>
                  </div>
                </div>

                <div className={`col-lg-12 col-md-12 p-3 px-5`}>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-4 pe-0 border-end">
                        <select
                          id="dialCode"
                          name="dialCode"
                          className={`form-control form-select`}
                          style={{
                            textAlignLast: "center",
                            fontSize: "1.2rem",
                            borderBottomRightRadius: "unset",
                            borderTopRightRadius: "unset",
                          }}
                          onChange={e => {
                            setCountry(e.target.value)
                          }}
                          defaultValue={selectedCountry}
                        >
                          {countryCode &&
                            countryCode.map(country => (
                              <option
                                key={`k-${country.name}`}
                                value={country.dialCode}
                              >
                                {country.dialCode === selectedCountry
                                  ? country.dialCode
                                  : `${country.name} ${country.dialCode}`}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col-8 ps-0">
                        <input
                          type="tel"
                          // pattern="^\d{10}$"
                          name="mobileNumber"
                          placeholder="Phone Number"
                          className={`form-control ${
                            errors.mobileNumber && "is-invalid"
                          }`}
                          onChange={() => isValid()}
                          style={{
                            fontSize: "1.2rem",
                            borderBottomLeftRadius: "unset",
                            borderTopLeftRadius: "unset",
                          }}
                        />
                      </div>
                    </div>

                    <div className="invalid-feedback">
                      Please provide valid phone number.
                    </div>
                  </div>
                </div>

                <div className="col-lg-8 col-md-8 d-grid gap-2 mx-auto">
                  <button
                    className="btn btn-gradient services-button enquiry-button"
                    type="submit"
                  >
                    Submit Now
                  </button>
                </div>
                {showSuccess && (
                  <div className="col-lg-12 col-md-12 d-grid gap-2 mx-auto p-2">
                    <div className="alert alert-success" role="alert">
                      Thank you for booking
                    </div>
                  </div>
                )}
                {showError && (
                  <div className="col-lg-12 col-md-12 d-grid gap-2 mx-auto p-2">
                    <div className="alert alert-danger" role="alert">
                      Something Went wrong, Please Try again!
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        id="TripModal"
        // show={isOpen}
        // onHide={}
        // size="lg"
        // aria-labelledby="contained-modal-title-vcenter"

        isOpen={isOpen}
        centered={true}
        className="modal-dialog-centered modal-xl"
      >
        <div className="modal-header" style={{ borderBottom: "none" }}>
          <button
            type="button"
            className="btn-close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={knowMore}
          ></button>
        </div>

        <iframe
          src={hornbillFestival}
          frameBorder="0"
          scrolling="auto"
          height="100%"
          width="100%"
          style={{
            minWidth: 720,
            minHeight: 750,
          }}
        ></iframe>
      </Modal>
    </>
  )
}

export default TripSC
